/**
 * Teeny little + icon that changes when the accodion toggles
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { pink500 } from '../../ui/colors';
// import style from './AccordionIcon.module.scss';

interface AccordionIconProps{
  // add AccordionIcon props here
  className?: string;
  eventKey: String;
  currentActiveKey : String;
}

const AccordionIcon: React.FC<AccordionIconProps> = ({ className, eventKey, currentActiveKey } : AccordionIconProps) => {
  const active = (eventKey === currentActiveKey);
  return (
    <div className={`relative ${className || ''}`}>
      <FontAwesomeIcon icon={active ? faMinusCircle : faPlusCircle} color={pink500} />

    </div>
  );
};

export default AccordionIcon;
